(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mega-menu_products"] && !Shopify.designMode) return;
  try {
    function resetMegaMenuProducts(block) {
        const filterItems = block.querySelectorAll('.mega-menu-products-filter-item');
        const listItems = block.querySelectorAll('.mega-menu-products-list-item');

        filterItems.forEach(function(item, index) {
            item.classList.toggle('link--nav-underlined', index === 0);
            item.classList.toggle('link--nav', index !== 0);
        });

        listItems.forEach(function(item, index) {
            item.classList.toggle('active', index === 0);
        });
    }

    function activateFilter(filterItem) {
        const filterItems = filterItem.closest('.mega-menu-products-filters').querySelectorAll('.mega-menu-products-filter-item');
        filterItems.forEach(function(item) {
            item.classList.remove('link--nav-underlined');
            item.classList.add('link--nav');
        });
    }

    function activateCollection(collectionId, filterItem) {
        const listItems = filterItem.closest('.has-filters').querySelectorAll('.mega-menu-products-list-item');
        listItems.forEach(function(listItem) {
            listItem.classList.toggle('active', listItem.dataset.collectionId === collectionId);
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        const menuCloseDelay = 400;

        document.querySelectorAll('.mega-menu-block.has-filters').forEach(function(block) {
            const headerMenu = block.closest('.header-menu');
            let resetTimer;

            function scheduleReset() {
                clearTimeout(resetTimer);
                resetTimer = setTimeout(function() {
                    resetMegaMenuProducts(block);
                }, menuCloseDelay);
            }

            if (headerMenu) {
                headerMenu.addEventListener('mouseleave', scheduleReset);
                headerMenu.addEventListener('mouseenter', function() {
                    clearTimeout(resetTimer);
                });

                if (headerMenu.tagName === 'DETAILS') {
                    new MutationObserver(function() {
                        if (headerMenu.hasAttribute('open')) {
                            clearTimeout(resetTimer);
                        } else {
                            scheduleReset();
                        }
                    }).observe(headerMenu, { attributes: true, attributeFilter: ['open'] });
                }
            }

            block.querySelectorAll('.mega-menu-products-filter-item').forEach(function(item) {
                item.addEventListener('mouseover', function() {
                    activateFilter(item);
                    activateCollection(item.dataset.collectionId, item);
                });
                item.addEventListener('mouseleave', function() {
                    item.classList.add('link--nav-underlined');
                    item.classList.remove('link--nav');
                });
            });
        });
    });
  } catch(e) { console.error(e); }
})();

})();
